/* eslint-disable react/require-default-props */
/* eslint-disable react/forbid-prop-types */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Collapse, UnmountClosed } from 'react-collapse';
import useControlled from '../hooks/useControlled';

const Accordion = (props) => {

  const {
    children: childrenProp,
    defaultExpanded,
    expanded: expandedProp,
    onChange,
    collapseProps = {}
  } = props;

  const [expanded, setExpandedState] = useControlled({
    controlled: expandedProp,
    defaultValue: defaultExpanded
  });

  useEffect(() => {
    if (defaultExpanded) {
      setExpandedState(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = React.useCallback(
    (event) => {
      setExpandedState(!expanded);

      if (onChange) {
        onChange(event, !expanded);
      }
    },
    [expanded, onChange, setExpandedState],
  );

  const [summary, ...children] = React.Children.toArray(childrenProp);

  const headerComp = React.cloneElement(summary, {
    expanded,
    toggle: handleChange,
  });

  const borderClasses = 'sui-border-1 sui-border-solid sui-border-primary sui-rounded-b-base sui-border-t-0';

  const transitionClasses = 'sui-transition-all sui-duration-250';

  const collapseClasses = classNames(
    // 'sui-w-full sui-bg-primary sui-mb-2',
    borderClasses,
    transitionClasses, {
      'sui-border-transparent': !expanded
    });

  const theme = {
    collapse: collapseClasses,
    content: 'sui-flex sui-w-full'
  };

  const { unmountOnClosed = false } = collapseProps;

  return (
    <div className="sui-bg-primary sui-text-primary sui-relative sui-mb-2">
      {headerComp}
      {unmountOnClosed ? (
        <UnmountClosed isOpened={expanded} theme={theme}>
          <div className="sui-w-full">
            <div
              aria-labelledby={summary.props.id}
              id={summary.props['aria-controls']}
              role="region"
            >
              {children}
            </div>
          </div>
        </UnmountClosed>
      ) : (
        <Collapse isOpened={expanded} theme={theme}>
          <div className="sui-w-full">
            <div
              aria-labelledby={summary.props.id}
              id={summary.props['aria-controls']}
              role="region"
            >
              {children}
            </div>
          </div>
        </Collapse>
      )}
    </div>
  );
};

Accordion.displayName = 'Accordion';

Accordion.propTypes = {
  /**
   * @ignore
   */
  children: PropTypes.node,
  /**
   * Expands the AccordionBody component when first rendered.
   */
  defaultExpanded: PropTypes.bool,
  /**
   * Expands the AccordionBody component.
   */
  expanded: PropTypes.bool,
  /**
   * The onChange attribute that is added to the AccordionHeader component.
   */
  onChange: PropTypes.func,
  /**
   * Props applied to the collapse element.
   */
  collapseProps: PropTypes.object,
};

export { Accordion };